import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Get in touch`}</h1>
    <p>{`Contact me, email me `}<a parentName="p" {...{
        "href": "mailto:mtgsquad.dev@protonmail.com"
      }}>{`here`}</a>{`, Or via twitter `}<a parentName="p" {...{
        "href": "https://twitter.com/mtgsquad_dev"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      